// extracted by mini-css-extract-plugin
export default {"menu":"ProjectNavigationV3_menu__l-nIb","menuItem":"ProjectNavigationV3_menuItem__YfyqU","active":"ProjectNavigationV3_active__z-NDU"};